export enum NeedToControlled {
    HYGIENE = 'hygiene',
    CHANGE_CLOTHES = 'change-clothes',
    DRYING_CLOTHES = 'drying-clothes',
    OTHER = 'other',
}

export const needToControlledTranslates = {
    [NeedToControlled.HYGIENE]: 'Личная гигиена',
    [NeedToControlled.CHANGE_CLOTHES]: 'Переодеться, если сыро и холодно',
    [NeedToControlled.DRYING_CLOTHES]: 'Сушка и уход за вещами',
    [NeedToControlled.OTHER]: 'Другое',
};
